import moment from "moment";
import { IoIosArrowDropleft, IoIosArrowDropright } from "react-icons/io";

const DateRangeComponent = ({
  handleDateChange,
  startDate,
  endDate,
}: {
  handleDateChange: CallableFunction;
  startDate: string;
  endDate: string;
}) => {
  return (
    <div className="d-flex align-items-center justify-content-center fs-20 fw-600 text-grey-500">
      <IoIosArrowDropleft
        size={32}
        className="cursor-pointer"
        onClick={() => {
          handleDateChange("subtract");
        }}
      />
      <span className="mx-2">
        {moment(startDate).format("DD MMM")} -{" "}
        {moment(endDate).format("DD MMM YYYY")}
      </span>
      <IoIosArrowDropright
        size={32}
        className="cursor-pointer"
        onClick={() => {
          handleDateChange("add");
        }}
      />
    </div>
  );
};

export default DateRangeComponent;
